import ExclamationIcon from "~/assets/icons/ExclamationIcon";
import { getCurrencyByFormatting, getCurrencyValue } from "~/lib/utils";
import { VariantEdgeMetafields } from "~/types";
import { isNonTransactional, showPriceshowPriceTransactional } from "../../../../setup/settings/__nonTransactional";
import { sotckOptionUserLetter, stockSectionWithoutNumber } from "../../../../setup/settings/__product";

type Props =
  {
    variants: VariantEdgeMetafields[],
    setVariant: (v: VariantEdgeMetafields) => void,
    setSelectedVariant: (v: string) => void,
    selectedVariant: string,
    setShowCustomize: (b: boolean) => void,
    redPriceStock: boolean,
    currency: string,
    setModalType: (value: number) => void
  }

export default function VariantDetails({ variants, setVariant, setSelectedVariant,
  selectedVariant, setShowCustomize, redPriceStock, currency, setModalType }: Props) {
  return (
    <div className="variants">
      {(!isNonTransactional || showPriceshowPriceTransactional) && variants.map((variant: VariantEdgeMetafields, i: number) => {
        const ascciA = 65;
        const index = sotckOptionUserLetter ? String.fromCharCode(ascciA + i) : i + 1;
        return (
          <VariantCard
            variant={variant}
            setVariant={setVariant}
            setSelectedVariant={setSelectedVariant}
            selectedVariant={selectedVariant}
            setShowCustomize={setShowCustomize}
            redPriceStock={redPriceStock}
            currency={currency}
            index={index} 
            setModalType={setModalType}
          />
        );
      })}
    </div>
  )
}

type PropsCard =
  {
    variant: VariantEdgeMetafields
    setVariant: (v: VariantEdgeMetafields) => void,
    setSelectedVariant: (v: string) => void,
    selectedVariant: string,
    setShowCustomize: (b: boolean) => void,
    redPriceStock: boolean,
    currency: string,
    index: any,
    setModalType: (value: number) => void
  }

const VariantCard = ({ variant, setVariant, setSelectedVariant, setModalType,
  selectedVariant, setShowCustomize, redPriceStock, currency, index }: PropsCard) => {

  const openOptionVariant: (variant: VariantEdgeMetafields) => void = (variant: VariantEdgeMetafields) => {
    if (variant.node.price.amount.includes('.') && variant.node.price.amount.split('.')[1].length <= 1) {
      variant.node.price.amount = parseFloat(variant.node.price.amount).toFixed(2);
    }
    setVariant(variant);
    document.body.style.overflow = 'hidden';
    setModalType(1); setShowCustomize(true);
  }
  return (
    <div className={`variant-item ${selectedVariant == variant.node?.id && 'selected'}`} onClick={() => setSelectedVariant(variant.node.id)}>
      <div>
        {stockSectionWithoutNumber.enabled ? <span>{stockSectionWithoutNumber.text}</span> : <span>In Stock Option  {index}</span>}
        {(!isNonTransactional || showPriceshowPriceTransactional) &&
          <p className={redPriceStock === true ? "ProductList__price-red" : "ProductList__price"}>{getCurrencyValue(currency, variant.node?.price.amount)}</p>
        }
      </div>
      <span className="exclamation-circle" onClick={() => openOptionVariant(variant)}>
        <ExclamationIcon />
      </span>
    </div >
  )
}